import WidgetModule from "@eisinc/Overrides/Widgets/Footer/FooterContainer";

export * from "@eisinc/Overrides/Widgets/Footer/FooterContainer";

export default WidgetModule;
